export default "__VITE_ASSET__V7xxbi14__"